import { required } from "./validations";

const modelSchema = {
  LoginForm: {
    user: {
      name: "user",
      validate: [required("user")],
    },
    pwd: {
      name: "pwd",
      validate: [required("pwd")],
    },
  },
  HystoryRequestFormFilter: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },

    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "REQUEST_TYPE_LIST",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "REQUEST_STATUS_LIST",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    beneficiaryFilter: {
      name: "beneficiaryFilter",
      validate: [required("beneficiaryFilter")],
      componentType: "TextInputFieldUI",
    },
    creationDateFilter: {
      name: "creationDateFilter",
      validate: [required("creationDateFilter")],
      componentType: "DateRangePicker",
    },
    ticketNumberFilter: {
      name: "ticketNumberFilter",
      validate: [required("ticketNumberFilter")],
      componentType: "TextInputFieldUI",
    },
    applicantFilter: {
      name: "applicantFilter",
      validate: [required("applicantFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  AbilitationManagementStep2FormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    userIdFilter: {
      name: "userIdFilter",
      validate: [required("userIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("operativeUnitFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    userTypeFilter: {
      name: "userTypeFilter",
      validate: [required("userTypeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  AbilitationManagementStep3AbilitationFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  AbilitationManagementStep3AbilitationDateFormFilter: {
    dateTaken: {
      name: "dateTaken",
      validate: [required("dateTaken")],
      componentType: "DateRangePicker",
    },
  },
  AbilitationManagementStep3BRFormFilter: {
    allBRFilter: {
      name: "allBRFilter",
      validate: [required("allBRFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  DelegationManagementStep1FormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    delegatedFilter: {
      name: "delegatedFilter",
      validate: [required("delegatedFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    startDateFilter: {
      name: "startDateFilter",
      validate: [required("startDateFilter")],
      componentType: "DateRangePicker",
      advanced: true,
    },
    endDateFilter: {
      name: "endDateFilter",
      validate: [required("endDateFilter")],
      componentType: "DateRangePicker",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  DelegationManagementStep3FormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    managerFullNameFilter: {
      name: "managerFullNameFilter",
      validate: [required("managerFullNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    emailFilter: {
      name: "emailFilter",
      validate: [required("emailFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    userIdFilter: {
      name: "userIdFilter",
      validate: [required("userIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("operativeUnitFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    userTypeFilter: {
      name: "userTypeFilter",
      validate: [required("userTypeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  TechnicalUserStepOneFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    usertypeFilter: {
      name: "usertypeFilter",
      validate: [required("usertypeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "USERTYPE_LIST",
    },
  },
  TechnicalUserStepTwoFormFilter: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TU_STATUS_LIST",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  ApprovalsFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    idFilter: {
      name: "idFilter",
      validate: [required("id")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "APPROVAL_REQUEST_TYPE_LIST",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    beneficiaryFilter: {
      name: "beneficiaryFilter",
      validate: [required("beneficiary")],
      componentType: "TextInputFieldUI",
    },
    creationDateFilter: {
      name: "creationDateFilter",
      validate: [required("creationDateFilter")],
      componentType: "DateRangePicker",
    },
    baoFilter: {
      name: "baoFilter",
      validate: [required("baoFilter")],
      componentType: "TextInputFieldUI",
    },
    applicantFilter: {
      name: "applicantFilter",
      validate: [required("applicant")],
      componentType: "TextInputFieldUI",
    },
  },
  TasksFormFilter: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TASK_REQUEST_ACTION_LIST",
    },
    applicantFilter: {
      name: "applicantFilter",
      validate: [required("applicant")],
      componentType: "TextInputFieldUI",
    },
    inChargeOfFilter: {
      name: "inChargeOfFilter",
      validate: [required("inChargeOfFilter")],
      componentType: "TextInputFieldUI",
    },
    beneficiaryFilter: {
      name: "beneficiaryFilter",
      validate: [required("beneficiary")],
      componentType: "TextInputFieldUI",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("application")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("abilitation")],
      componentType: "TextInputFieldUI",
    },
    creationDateFilter: {
      name: "creationDateFilter",
      validate: [required("creationDateFilter")],
      componentType: "DateRangePicker",
    },
  },
  CatalogFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  CatalogEntitlementFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  UserReferencesFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    managerFullNameFilter: {
      name: "managerFullNameFilter",
      validate: [required("managerFullNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    emailFilter: {
      name: "emailFilter",
      validate: [required("emailFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    netsIdFilter: {
      name: "netsIdFilter",
      validate: [required("netsIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    netsOrgunitIdFilter: {
      name: "netsOrgunitIdFilter",
      validate: [required("netsOrgunitIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    netsPersonIdFilter: {
      name: "netsPersonIdFilter",
      validate: [required("netsPersonIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },

  UserReferencesDetailUsersFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    lastChangePwdFilter: {
      name: "lastChangePwdFilter",
      validate: [required("lastChangePwdFilter")],
      componentType: "DateRangePicker",
      advanced: true,
    },
    numberLoginErrorFilter: {
      name: "numberLoginErrorFilter",
      validate: [required("numberLoginErrorFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    forceChangePwdFilter: {
      name: "forceChangePwdFilter",
      validate: [required("forceChangePwdFilter")],
      componentType: "ToggleField",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  UserReferencesDetailManagersFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    userCodeFilter: {
      name: "userCodeFilter",
      validate: [required("userCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    managerFilter: {
      name: "managerFilter",
      validate: [required("managerFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  UserReferencesDetailOusFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  UserReferencesDetailEntitlementsFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  EntitlementReferenceFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  EntitlementReferenceDetailFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    userIdFilter: {
      name: "userIdFilter",
      validate: [required("userIdFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
    },
    emailFilter: {
      name: "emailFilter",
      validate: [required("emailFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  userEntitlementsFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  technicalUserCreateStepTwoCatalogEntitlement: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  technicalUserCreateStepTwoExisting: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  EmergencyUsersFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    maxValidityHoursFilter: {
      name: "maxValidityHoursFilter",
      validate: [required("maxValidityHoursFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  EmergencyUsersDetailFormFilter: {
    maxValidityHoursFilter: {
      name: "maxValidityHoursFilter",
      validate: [required("maxValidityHoursFilter")],
      componentType: "TextInputFieldUI",
      typeField: "number",
      inputProps: { min: 0, max: 8 },
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "REQUEST_TYPE_LIST",
    },
  },
  BRManagementStep2FormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  BRManagementBRFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  AbilitationManagementStep3EntitlementsFormFilter: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  BRManagementEntitlementsFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  CertificationRequestFormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    endDateFilter: {
      name: "endDateFilter",
      validate: [required("endDateFilter")],
      componentType: "DateRangePicker",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_TYPE_LIST",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
    applicantFilter: {
      name: "applicantFilter",
      validate: [required("applicantFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  certificationReferenceCampaignRevisorFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  certificationReferenceStepTwoUserFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoOUFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoApplicationFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoBusinessRoleFormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoEntitlementFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoAccountFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
  },
  certificationReferenceStepTwoTechnicalUserFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_STATUS_LIST",
    },
    technicalUserTypeFilter: {
      name: "technicalUserTypeFilter",
      validate: [required("technicalUserTypeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TECHNICAL_USER_TYPE_LIST",
    },
  },
  certificationReferenceStepThreeUserFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    userIdFilter: {
      name: "userIdFilter",
      validate: [required("userIdFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    revisorFilter: {
      name: "revisorFilter",
      validate: [required("revisorFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeOUFormFilter: {
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeApplicationFormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeBusinessRoleFormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeEntitlementFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    revisorFilter: {
      name: "revisorFilter",
      validate: [required("revisorFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeTechnicalUsersFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    revisorFilter: {
      name: "revisorFilter",
      validate: [required("revisorFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  certificationReferenceStepThreeAccountFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    userIdFilter: {
      name: "userIdFilter",
      validate: [required("userIdFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_STATUS_LIST",
    },
    revisorFilter: {
      name: "revisorFilter",
      validate: [required("revisorFilter")],
      componentType: "TextInputFieldUI",
    },
    actionFilter: {
      name: "actionFilter",
      validate: [required("actionFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_ITEM_ACTION_LIST",
    },
  },
  resetPasswordFormFilter: {
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    accountIdFilter: {
      name: "accountIdFilter",
      validate: [required("accountIdFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  supervisorsFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  supervisorsAddedFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  RevisorFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  GroupsPerimeterFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    managerIdFilter: {
      name: "managerIdFilter",
      validate: [required("managerIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  GroupsPerimeterFormAdded: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    managerIdFilter: {
      name: "managerIdFilter",
      validate: [required("managerIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },
  UsersCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  UserAddedCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  ApplicationCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  ApplicationsAddedCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  BrCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  BrAddedCreateCertificationFormRequest: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  EntitlementsCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  EntitlementsAddedCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  TechnicalUsersCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    technicalUserTypeFilter: {
      name: "technicalUserTypeFilter",
      validate: [required("technicalUserTypeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TECHNICAL_USER_TYPE_LIST",
      advanced: true,
    },
  },
  TechnicalUsersAddedCreateCertificationFormRequest: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
    technicalUserTypeFilter: {
      name: "technicalUserTypeFilter",
      validate: [required("technicalUserTypeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TECHNICAL_USER_TYPE_LIST",
      advanced: true,
    },
  },

  UserManagementFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
    },
    managerFullNameFilter: {
      name: "managerFullNameFilter",
      validate: [required("managerFullNameFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  UsersManagementStep3AbilitationFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  UsersManagementStep3BRFormFilter: {
    allBRFilter: {
      name: "allBRFilter",
      validate: [required("allBRFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },

  UsersManagementStep3EntitlementsFormFilter: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  UsersManagementDetailEntitlementsFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    statusFilter: {
      name: "statusFilter",
      validate: [required("statusFilter")],
      componentType: "SelectFieldUI",
      listFilter: "ACCOUNT_STATUS_LIST",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  UsersManagementDetailMannagersFormFilter: {
    userCodeFilter: {
      name: "userCodeFilter",
      validate: [required("userCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    userCatalogFilter: {
      name: "userCatalogFilter",
      validate: [required("userCatalogFilter")],
      componentType: "TextInputFieldUI",
    },
    userManagerFilter: {
      name: "userManagerFilter",
      validate: [required("userManagerFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  UsersManagementDetailOusFormFilter: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  ManualsReferenceFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    uploadDateFilter: {
      name: "uploadDateFilter",
      validate: [required("uploadDateFilter")],
      componentType: "DateRangePicker",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  ReportFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  TemplateMailFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    subjectFilter: {
      name: "subjectFilter",
      validate: [required("subjectFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  TemplateSmsFormFilter: {
    operationFilter: {
      name: "operationFilter",
      validate: [required("operationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  CatalogFormFilterConsoleAdmin: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },

  WorkflowFirstPanelFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  ManualsSectionStepOneConsoleAdminFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  UsersManagementFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    typologyFilter: {
      name: "typologyFilter",
      validate: [required("typologyFilter")],
      componentType: "SelectFieldUI",
      listFilter: "EXTERNAL_PORTAL_TYPOLOGY_LIST",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    externalCompanyDescFilter: {
      name: "externalCompanyDescFilter",
      validate: [required("externalCompanyDescFilter")],
      componentType: "TextInputFieldUI",
    },
    statusIdFilter: {
      name: "statusIdFilter",
      validate: [required("statusIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "EXTERNAL_PORTAL_STATUS_LIST",
    },
    relationshipEndDateFilter: {
      name: "relationshipEndDateFilter",
      validate: [required("relationshipEndDateFilter")],
      componentType: "DateRangePicker",
    },
    companyEmailFilter: {
      name: "companyEmailFilter",
      validate: [required("companyEmailFilter")],
      componentType: "TextInputFieldUI",
    },
    managerFilter: {
      name: "managerFilter",
      validate: [required("managerFilter")],
      componentType: "TextInputFieldUI",
    },
    referralFilter: {
      name: "referralFilter",
      validate: [required("referralFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  SocietyValidationFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  CatalogEntitlementFormFilterConsoleAdmin: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },
  WorkflowSecondPanelFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    workflowIdFilter: {
      name: "workflowIdFilter",
      validate: [required("workflowIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  WorkflowThirdPanelFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    stepCodeFilter: {
      name: "stepCodeFilter",
      validate: [required("stepCodeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    approverFilter: {
      name: "approverFilter",
      validate: [required("approverFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    stepDescriptionFilter: {
      name: "stepDescriptionFilter",
      validate: [required("stepDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    stepIdFilter: {
      name: "stepIdFilter",
      validate: [required("stepIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  CatalogFormFilterConsoleAdminSegregation: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    attributeFilter: {
      name: "attributeFilter",
      validate: [required("attributeFilter")],
      componentType: "TextInputFieldUI",
    },
    attributeValueFilter: {
      name: "attributeValueFilter",
      validate: [required("attributeValueFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  CatalogFormFilterConsoleAdminStepOne: {
    ouCodeFilter: {
      name: "ouCodeFilter",
      validate: [required("ouCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    ownerFilter: {
      name: "ownerFilter",
      validate: [required("ownerFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  CatalogFormFilterConsoleAdminStepTwo: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  ManualsSectionStepThreeConsoleAdminFormFilter: {
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },

  ExternalPortalManagementConfigurationsFifthPanelFormFilter: {
    ouCodeFilter: {
      name: "ouCodeFilter",
      validate: [required("ouCodeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    ouTypeFilter: {
      name: "ouTypeFilter",
      validate: [required("ouTypeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    ouIdCounterFilter: {
      name: "ouIdCounterFilter",
      validate: [required("ouIdCounterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },

  ExternalPortalManagementConfigurationsSixthPanelFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    valueFilter: {
      name: "valueFilter",
      validate: [required("valueFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },

  ExternalPortalManagementConfigurationsFourthPanelFormFilter: {
    counterIdFilter: {
      name: "counterIdFilter",
      validate: [required("counterIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    counterLastIdFilter: {
      name: "counterLastIdFilter",
      validate: [required("counterLastIdFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    counterLengthFilter: {
      name: "counterLengthFilter",
      validate: [required("counterLengthFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    counterPrefixFilter: {
      name: "counterPrefixFilter",
      validate: [required("counterPrefixFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  ExternalPortalManagementConfigurationsFirstPanelFormFilter: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  ExternalPortalManagementConfigurationsSecondPanelFormFilter: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  ExternalPortalManagementConfigurationsThirdPanelFormFilter: {
    fieldCodeFilter: {
      name: "fieldCodeFilter",
      validate: [required("fieldCodeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    fieldAreaFilter: {
      name: "fieldAreaFilter",
      validate: [required("fieldAreaFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    fieldTypeFilter: {
      name: "fieldTypeFilter",
      validate: [required("fieldTypeFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    fieldOrderFilter: {
      name: "fieldOrderFilter",
      validate: [required("fieldOrderFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  passwordPropagationFormFilter: {
    sourceTargetIdFilter: {
      name: "sourceTargetIdFilter",
      validate: [required("sourceTargetIdFilter")],
      componentType: "TextInputFieldUI",
    },
    sourceIdentitySystemIdFilter: {
      name: "sourceIdentitySystemIdFilter",
      validate: [required("sourceIdentitySystemIdFilter")],
      componentType: "TextInputFieldUI",
    },
    destinationTargetIdFilter: {
      name: "destinationTargetIdFilter",
      validate: [required("destinationTargetIdFilter")],
      componentType: "TextInputFieldUI",
    },
    destinationIdentitySystemIdFilter: {
      name: "destinationIdentitySystemIdFilter",
      validate: [required("destinationIdentitySystemIdFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  sodManagementSodConflictsFilterForm: {
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    conflictEntitlementFilter: {
      name: "conflictEntitlementFilter",
      validate: [required("conflictEntitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    conflictApplicationFilter: {
      name: "conflictApplicationFilter",
      validate: [required("conflictApplicationFilter")],
      componentType: "TextInputFieldUI",
    },
    conflictFilter: {
      name: "conflictFilter",
      validate: [required("conflictFilter")],
      componentType: "SelectFieldUI",
      listFilter: "SOD_CONFLICT_TYPE_LIST",
    },
  },
  sodManagementConflictCreationEntitlementsFilterForm: {
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  ApplicationManagementFilterform: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  AdminEntitlementsManagementFilterForm: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    baoFilter: {
      name: "baoFilter",
      validate: [required("baoFilter")],
      componentType: "TextInputFieldUI",
    },
    showOnFrontendFilter: {
      name: "showOnFrontendFilter",
      validate: [required("showOnFrontendFilter")],
      componentType: "SelectFieldUI",
      listFilter: "SHOW_ON_FRONTEND_TYPE_LIST",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  AdminGlobalEntitlementsManagementFilterForm: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  AdminServReqTemplateTicketFormProps: {
    idTicketTemplateFilter: {
      name: "idTicketTemplateFilter",
      validate: [required("idTicketTemplateFilter")],
      componentType: "TextInputFieldUI",
    },
    idServiceRequestFilter: {
      name: "idServiceRequestFilter",
      validate: [required("idServiceRequestFilter")],
      componentType: "TextInputFieldUI",
    },
    ticketSystemIdFilter: {
      name: "ticketSystemIdFilter",
      validate: [required("ticketSystemIdFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  AdminServReqTemplateTicketFieldsFormProps: {
    idTemplateFilter: {
      name: "idTemplateFilter",
      validate: [required("idTemplateFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldNameFilter: {
      name: "fieldNameFilter",
      validate: [required("fieldNameFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldValueFilter: {
      name: "fieldValueFilter",
      validate: [required("fieldValueFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  AdminServReqFormProps: {
    serviceRequestIdFilter: {
      name: "serviceRequestIdFilter",
      validate: [required("serviceRequestIdFilter")],
      componentType: "TextInputFieldUI",
    },
    serviceRequestNameFilter: {
      name: "serviceRequestNameFilter",
      validate: [required("serviceRequestNameFilter")],
      componentType: "TextInputFieldUI",
    },
    displayOrderFilter: {
      name: "displayOrderFilter",
      validate: [required("displayOrderFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  AdminServReqFieldsFormProps: {
    idServiceRequestFilter: {
      name: "idServiceRequestFilter",
      validate: [required("idServiceRequestFilter")],
      componentType: "TextInputFieldUI",
    },
    serviceRequestNameFilter: {
      name: "serviceRequestNameFilter",
      validate: [required("serviceRequestNameFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldNameFilter: {
      name: "fieldNameFilter",
      validate: [required("fieldNameFilter")],
      componentType: "TextInputFieldUI",
    },
    idFieldFilter: {
      name: "idFieldFilter",
      validate: [required("idFieldFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldTypeFilter: {
      name: "fieldTypeFilter",
      validate: [required("fieldTypeFilter")],
      componentType: "TextInputFieldUI",
    },
    displayOrderFilter: {
      name: "displayOrderFilter",
      validate: [required("displayOrderFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  AdminServReqExtFieldsFormProps: {
    idExternalFilter: {
      name: "idExternalFilter",
      validate: [required("idExternalFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldIdFilter: {
      name: "fieldIdFilter",
      validate: [required("fieldIdFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldNameFilter: {
      name: "fieldNameFilter",
      validate: [required("fieldNameFilter")],
      componentType: "TextInputFieldUI",
    },
    fieldValueFilter: {
      name: "fieldValueFilter",
      validate: [required("fieldValueFilter")],
      componentType: "TextInputFieldUI",
    },
    serviceRequestIdFilter: {
      name: "serviceRequestIdFilter",
      validate: [required("serviceRequestIdFilter")],
      componentType: "TextInputFieldUI",
    },
    serviceRequestNameFilter: {
      name: "serviceRequestNameFilter",
      validate: [required("serviceRequestNameFilter")],
      componentType: "TextInputFieldUI",
    },
    displayOrderFilter: {
      name: "displayOrderFilter",
      validate: [required("displayOrderFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  AdminChainEntitlementsManagementFilterForm: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  sodManagementExceptionCreationUserFilterForm: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  userRolesManagementFormFilter: {
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    supervisorFilter: {
      name: "supervisorFilter",
      validate: [required("supervisorFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  userRoleMgmtUserDetailsFilterForm: {
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  rolesManagementRolesFilterForm: {
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  rolesManagementVisibilityConesFilterForm: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
    },
    objectFilter: {
      name: "objectFilter",
      validate: [required("objectFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  rolesManagementSearchUsersFilterForm: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    uidMasterFilter: {
      name: "uidMasterFilter",
      validate: [required("uidMasterFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  reportMgmtRepoFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    queryFilter: {
      name: "queryFilter",
      validate: [required("queryFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  reportMgmtParamFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    parameterFilter: {
      name: "parameterFilter",
      validate: [required("parameterFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    propertyFilter: {
      name: "propertyFilter",
      validate: [required("propertyFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    valueFilter: {
      name: "valueFilter",
      validate: [required("valueFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  notificationManagementFormFilter: {
    titleFilter: {
      name: "titleFilter",
      validate: [required("titleFilter")],
      componentType: "TextInputFieldUI",
    },
    textFilter: {
      name: "textFilter",
      validate: [required("textFilter")],
      componentType: "TextInputFieldUI",
    },
    startDateFilter: {
      name: "startDateFilter",
      validate: [required("startDateFilter")],
      componentType: "DateRangePicker",
    },
  },
  recoveryPointUserFilterForm: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    surnameFilter: {
      name: "surnameFilter",
      validate: [required("surnameFilter")],
      componentType: "TextInputFieldUI",
    },
    codeFilter: {
      name: "codeFilter",
      validate: [required("codeFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    supervisorFullNameFilter: {
      name: "supervisorFullNameFilter",
      validate: [required("supervisorFullNameFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  recoveryPointAbilitationFilterForm: {
    applicationIdFilter: {
      name: "applicationIdFilter",
      validate: [required("applicationIdFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementIdFilter: {
      name: "entitlementIdFilter",
      validate: [required("entitlementIdFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  recoveryPointStepTwoFilterForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  recoveryPointStepTwoEntitlementsFilterForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },

  recoveryPointThirdStepAbilitationFilterForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  consoleAdminCertificationConfigurationsFilterForm: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "CERTIFICATION_MANAGEMENT_TYPE_LIST",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    durationFilter: {
      name: "durationFilter",
      validate: [required("durationFilter")],
      componentType: "TextInputFieldUI",
      typeField: "number",
      props: {
        type: "number",
      },
    },
  },

  recoveryPointThirdStepEntitlementsFilterForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },

  auditFilterForm: {
    idFilter: {
      name: "idFilter",
      validate: [required("idFilter")],
      componentType: "TextInputFieldUI",
    },
    auditDateFilter: {
      name: "auditDateFilter",
      validate: [required("auditDateFilter")],
      componentType: "DateRangePicker",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    objectDescFilter: {
      name: "objectDescFilter",
      validate: [required("objectDescFilter")],
      componentType: "TextInputFieldUI",
    },
    objectIdFilter: {
      name: "objectIdFilter",
      validate: [required("objectIdFilter")],
      componentType: "TextInputFieldUI",
    },
    objectIdentitySystemIdFilter: {
      name: "objectIdentitySystemIdFilter",
      validate: [required("objectIdentitySystemIdFilter")],
      componentType: "TextInputFieldUI",
    },
    objectTypeFilter: {
      name: "objectTypeFilter",
      validate: [required("objectTypeFilter")],
      componentType: "TextInputFieldUI",
    },
    operationFilter: {
      name: "operationFilter",
      validate: [required("operationFilter")],
      componentType: "TextInputFieldUI",
    },
    operationByFilter: {
      name: "operationByFilter",
      validate: [required("operationByFilter")],
      componentType: "TextInputFieldUI",
    },
    subjectDescFilter: {
      name: "subjectDescFilter",
      validate: [required("subjectDescFilter")],
      componentType: "TextInputFieldUI",
    },
    subjectIdFilter: {
      name: "subjectIdFilter",
      validate: [required("subjectIdFilter")],
      componentType: "TextInputFieldUI",
    },
    subjectIdentitySystemIdFilter: {
      name: "subjectIdentitySystemIdFilter",
      validate: [required("subjectIdentitySystemIdFilter")],
      componentType: "TextInputFieldUI",
    },
    subjectTypeFilter: {
      name: "subjectTypeFilter",
      validate: [required("subjectTypeFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  ConsoleAdminBrMgmtStepOneFormFilter: {
    id: {
      name: "id",
      validate: [required("id")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    code: {
      name: "code",
      validate: [required("code")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    name: {
      name: "name",
      validate: [required("name")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    description: {
      name: "description",
      validate: [required("description")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    ownerCode: {
      name: "ownerCode",
      validate: [required("ownerCode")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },
  ConsoleAdminBrMgmtStepTwoFormFilter: {
    nameFilter: {
      name: "nameFilter",
      validate: [required("nameFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    ouFilter: {
      name: "ouFilter",
      validate: [required("ouFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  ConsoleAdminBrManagementStepThreeEntitlementsFormFilter: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
  },
  ConsoleAdminBrManagementStepThreeBrEntitlementsFormFilter: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
  },

  applicationsListConsoleAdminTemporaryAbilitationMgmtForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  temporaryAbilitationsFilterConsoleAdminApplicationsConfigurationsMgmtForm: {
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  totalTemporaryAbilitationsFilterConsoleAdminApplicationsConfigurationsMgmtForm:
    {
      abilitationFilter: {
        name: "abilitationFilter",
        validate: [required("abilitationFilter")],
        componentType: "TextInputFieldUI",
      },
      abilitationDescriptionFilter: {
        name: "abilitationDescriptionFilter",
        validate: [required("abilitationDescriptionFilter")],
        componentType: "TextInputFieldUI",
      },
      identitySystemIdFilter: {
        name: "identitySystemIdFilter",
        validate: [required("identitySystemIdFilter")],
        componentType: "SelectFieldUI",
        listFilter: "IDENTITY_SYSTEM_LIST",
      },
    },
  manageTemporaryAbilitationsStepTwoAddedAbilitationsFormProps: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  manageTemporaryAbilitationsStepTwoRemovedAbilitationsFormProps: {
    entitlementNameFilter: {
      name: "entitlementNameFilter",
      validate: [required("entitlementNameFilter")],
      componentType: "TextInputFieldUI",
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationNameFilter: {
      name: "applicationNameFilter",
      validate: [required("applicationNameFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  temporaryAbilitationsListTemporaryEntitlementsForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  temporaryAbilitationsConfigurationTemporaryEntitlementsForm: {
    validityHoursFilter: {
      name: "validityHoursFilter",
      validate: [required("validityHoursFilter")],
      componentType: "TextInputFieldUI",
    },
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  temporaryEmergencyConfigurationTemporaryEntitlementsForm: {
    validityHoursFilter: {
      name: "validityHoursFilter",
      validate: [required("validityHoursFilter")],
      componentType: "TextInputFieldUI",
    },
    roleFilter: {
      name: "roleFilter",
      validate: [required("roleFilter")],
      componentType: "TextInputFieldUI",
    },
    emergencyNameFilter: {
      name: "emergencyNameFilter",
      validate: [required("emergencyNameFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  temporaryEmergencyConfigurationGlobalCatalogForm: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },
  temporaryEmergencyConfigurationMandatoryForm: {
    allFilter: {
      name: "allFilter",
      validate: [required("allFilter")],
      componentType: "TextInputFieldUI",
      advanced: false,
    },

    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementFilter: {
      name: "entitlementFilter",
      validate: [required("entitlementFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    entitlementDescriptionFilter: {
      name: "entitlementDescriptionFilter",
      validate: [required("entitlementDescriptionFilter")],
      componentType: "TextInputFieldUI",
      advanced: true,
    },
    advancedSearchFilter: {
      name: "advancedSearchFilter",
      validate: [required("advancedSearchFilter")],
      componentType: "ToggleField",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
      advanced: true,
    },
  },
  temporaryAbilitationsListForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "APPLICATION_CONFIGURATION_TYPE_LIST",
    },
    availableFilter: {
      name: "availableFilter",
      validate: [required("availableFilter")],
      componentType: "TextInputFieldUI",
    },
    maxDurationFilter: {
      name: "maxDurationFilter",
      validate: [required("maxDurationFilter")],
      componentType: "TextInputFieldUI",
      typeField: "number",
      props: { type: "number" },
    },
    userCodeFilter: {
      name: "userCodeFilter",
      validate: [required("userCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  emergencyTemporaryAbilitationsListForm: {
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationFilter: {
      name: "abilitationFilter",
      validate: [required("abilitationFilter")],
      componentType: "TextInputFieldUI",
    },
    abilitationDescriptionFilter: {
      name: "abilitationDescriptionFilter",
      validate: [required("abilitationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    emergencyNameFilter: {
      name: "emergencyNameFilter",
      validate: [required("emergencyNameFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "APPLICATION_CONFIGURATION_TYPE_LIST",
    },
    availableFilter: {
      name: "availableFilter",
      validate: [required("availableFilter")],
      componentType: "TextInputFieldUI",
    },
    maxDurationFilter: {
      name: "maxDurationFilter",
      validate: [required("maxDurationFilter")],
      componentType: "TextInputFieldUI",
      props: { type: "number" },
    },
    userCodeFilter: {
      name: "userCodeFilter",
      validate: [required("userCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  adminTechnicalUserAllCounterFormProps: {
    counterCodeFilter: {
      name: "counterCodeFilter",
      validate: [required("counterCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    typeFilter: {
      name: "typeFilter",
      validate: [required("typeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TU_COUNTER_TYPE_LIST",
    },
    activeFilter: {
      name: "activeFilter",
      validate: [required("activeFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TU_BOOL_TYPE_LIST",
    },
    prefixFilter: {
      name: "prefixFilter",
      validate: [required("prefixFilter")],
      componentType: "TextInputFieldUI",
    },
    counterFilter: {
      name: "counterFilter",
      validate: [required("counterFilter")],
      componentType: "TextInputFieldUI",
    },
    lengthFilter: {
      name: "lengthFilter",
      validate: [required("lengthFilter")],
      componentType: "TextInputFieldUI",
    },
    defaultFilter: {
      name: "defaultFilter",
      validate: [required("defaultFilter")],
      componentType: "SelectFieldUI",
      listFilter: "TU_BOOL_TYPE_LIST",
    },
  },
  adminTechnicalUserAppCounterFormProps: {
    counterCodeFilter: {
      name: "counterCodeFilter",
      validate: [required("counterCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
    applicationFilter: {
      name: "applicationFilter",
      validate: [required("applicationFilter")],
      componentType: "TextInputFieldUI",
    },
    applicationDescriptionFilter: {
      name: "applicationDescriptionFilter",
      validate: [required("applicationDescriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  adminTechnicalUserOuCounterFormProps: {
    counterCodeFilter: {
      name: "counterCodeFilter",
      validate: [required("counterCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    organizationalUnitFilter: {
      name: "organizationalUnitFilter",
      validate: [required("organizationalUnitFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
  },
  adminTechnicalUsersRiorgFormFilter: {
    tiCodeFilter: {
      name: "tiCodeFilter",
      validate: [required("tiCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    oldOuCodeFilter: {
      name: "oldOuCodeFilter",
      validate: [required("oldOuCodeFilter")],
      componentType: "TextInputFieldUI",
    },
    oldManagerFilter: {
      name: "oldManagerFilter",
      validate: [required("oldManagerFilter")],
      componentType: "TextInputFieldUI",
    },
    identitySystemIdFilter: {
      name: "identitySystemIdFilter",
      validate: [required("identitySystemIdFilter")],
      componentType: "SelectFieldUI",
      listFilter: "IDENTITY_SYSTEM_LIST",
    },
  },
  ugipConfigurationFormProps: {
    configurationFilter: {
      name: "configurationFilter",
      validate: [required("configurationFilter")],
      componentType: "TextInputFieldUI",
    },
    descriptionFilter: {
      name: "descriptionFilter",
      validate: [required("descriptionFilter")],
      componentType: "TextInputFieldUI",
    },
    valueFilter: {
      name: "valueFilter",
      validate: [required("valueFilter")],
      componentType: "TextInputFieldUI",
    },
  },
};

export default modelSchema;
